import { useApp } from '../context.js';
import TagPicker from './TagPicker.jsx';
import { suggestCategories } from '../lib/categories.js';
import { Check } from '../icons.jsx';

export default function AddPlaceForm() {
    const { addRestaurant, autocompleteReady, newRestaurant, setNewRestaurant, setShowAddForm, t } = useApp();
    return (
        <div className="bg-white/90 apple-card rounded-2xl shadow-md overflow-hidden mb-4">
            {/* Header */}
            <div className={`bg-gradient-to-r ${t.accent} px-6 py-4 flex items-center justify-between`}>
                <h3 className="text-white font-bold text-lg">Add Restaurant</h3>
                <button
                    onClick={() => {
                        setShowAddForm(false);
                        setNewRestaurant({ name: '', address: '', coordinates: null, placeId: null });
                        const searchInput = document.getElementById('restaurant-search-input');
                        if (searchInput) searchInput.value = '';
                    }}
                    className="text-white/80 hover:text-white text-2xl font-light"
                >
                    ×
                </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-4">
                {/* Search Input */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Search Restaurant
                    </label>
                    <input
                        id="restaurant-search-input"
                        type="text"
                        placeholder="Search for a restaurant..."
                        className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-lg"
                    />
                    <p className={`mt-2 text-xs ${autocompleteReady ? 'text-green-600' : t.accentText}`}>
                        {autocompleteReady ? '✓ Start typing to see suggestions' : '⏳ Loading...'}
                    </p>
                </div>

                {/* Selected Address Display */}
                {newRestaurant.name && (
                    <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-xl border border-green-200">
                        <div className="flex items-start gap-3">
                            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                                <Check size={20} className="text-green-600" />
                            </div>
                            <div className="flex-1">
                                <div className="font-semibold text-gray-800">{newRestaurant.name}</div>
                                {newRestaurant.address && <div className="text-sm text-gray-600 mt-1">{newRestaurant.address}</div>}
                            </div>
                            <button
                                onClick={() => setNewRestaurant({name: '', address: '', coordinates: null, placeId: null})}
                                className="text-gray-400 hover:text-gray-600 p-2 touch-target"
                                aria-label="Clear selection"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                )}

                {/* Categories: suggested from Google types and the name; tap to change */}
                {newRestaurant.name && (
                    <div className="bg-white/70 rounded-xl p-3 border border-gray-100">
                        <p className="text-sm text-gray-600 mb-3">What kind of place is it? <span className="text-gray-400">(optional)</span></p>
                        <TagPicker
                            compact
                            value={{ cuisine: newRestaurant.cuisine || [], vibe: newRestaurant.vibe || [] }}
                            suggested={suggestCategories(newRestaurant.name, newRestaurant.placeTypes || [])}
                            onChange={(tags) => setNewRestaurant({ ...newRestaurant, ...tags })}
                        />
                    </div>
                )}

                {/* Manual Entry Option */}
                {!newRestaurant.name && (
                    <div className="border-t border-gray-200 pt-4">
                        <p className="text-sm text-gray-600 mb-3">Can't find it? Add manually:</p>
                        <div className="space-y-3">
                            <input
                                type="text"
                                id="manual-name-input"
                                placeholder="Restaurant name"
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors"
                            />
                            <input
                                type="text"
                                id="manual-address-input"
                                placeholder="Address (optional)"
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors"
                            />
                            <button
                                onClick={() => {
                                    const nameInput = document.getElementById('manual-name-input');
                                    const addressInput = document.getElementById('manual-address-input');
                                    if (nameInput.value.trim()) {
                                        const name = nameInput.value.trim();
                                        setNewRestaurant({
                                            name,
                                            address: addressInput.value.trim() || '',
                                            coordinates: null,
                                            placeId: null,
                                            ...suggestCategories(name, [])
                                        });
                                    }
                                }}
                                className="w-full bg-gray-100 text-gray-700 px-4 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
                            >
                                Use Manual Entry
                            </button>
                        </div>
                    </div>
                )}

                {/* Add Button */}
                <button
                    onClick={addRestaurant}
                    disabled={!newRestaurant.name.trim()}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white px-6 py-4 rounded-xl font-bold text-lg apple-button disabled:from-gray-300 disabled:to-gray-300 shadow-lg mt-4"
                >
                    Add Restaurant
                </button>

                {/* Cancel Button */}
                <button
                    onClick={() => {
                        setShowAddForm(false);
                        setNewRestaurant({ name: '', address: '', coordinates: null, placeId: null });
                    }}
                    className="w-full bg-gray-100 text-gray-600 px-4 py-3 rounded-xl font-semibold apple-button"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
}
